import { createStyles } from 'utils/css'

export const buttonStyle = (isSSO: boolean) =>
  createStyles(({ colors }) => ({
    textAlign: 'center',
    fontWeight: isSSO ? 'normal' : 600,
    color: isSSO ? colors.surface400 : colors.surface500
  }))
